export const VALID_APPLICATION_MODES = ['dev', 'prod'];
export const FALLBACK_APPLICATION_MODE = 'prod';
export const VALID_PROTOCOLS = ['http', 'https'];
